import React from 'react';
import { TOTAL_STEPS, STEP_TITLES, STEP_SUBTITLES } from './constants';

const WizardStepLayout = ({
  stepNumber,
  children,
  onBack,
  onNext,
  nextLabel,
  nextDisabled,
  nextPrimary,
  showBack,
  bottomExtra,
  topRightExtra,
  hideSubtitle,
}) => {
  const sub = STEP_SUBTITLES[stepNumber];
  return (
    <div className="wizard__step">
      <div className="wizard__step-label-row">
        <p className="wizard__step-label">
          STEP {stepNumber} OF {TOTAL_STEPS}
        </p>
        {topRightExtra && (
          <div className="wizard__step-label-right">{topRightExtra}</div>
        )}
      </div>
      <h2 className="wizard__step-heading">{STEP_TITLES[stepNumber]}</h2>
      {!hideSubtitle && sub ? (
        <p className="wizard__step-subtitle">{sub}</p>
      ) : null}

      <div className="wizard__step-content">{children}</div>

      <div className="wizard__nav-buttons">
        {showBack ? (
          <button className="wizard__nav-btn wizard__nav-btn--back" onClick={onBack}>
            &larr; Back
          </button>
        ) : (
          <span />
        )}
        {onNext && (
          <button
            className={
              'wizard__nav-btn ' +
              (nextPrimary ? 'wizard__nav-btn--submit' : 'wizard__nav-btn--next')
            }
            onClick={onNext}
            disabled={nextDisabled}
          >
            {nextLabel || 'Next \u2192'}
          </button>
        )}
      </div>

      {bottomExtra && (
        <div className="wizard__step-bottom-extra">{bottomExtra}</div>
      )}
    </div>
  );
};

export default React.memo(WizardStepLayout);
